var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "wrap": "",
      "id": "calls-list"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_vm.isOnline ? _c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "dark": "",
      "color": "green darken-4",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.refreshCalls
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("refresh")]), _vm._v("\n      " + _vm._s(_vm.$vuetify.t('$vuetify.calls.refreshCalls')) + "\n    ")], 1) : _c('v-btn', {
    attrs: {
      "large": "",
      "block": "",
      "dark": "",
      "color": "red darken-4"
    }
  }, [_c('v-icon', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "dark": ""
    }
  }, [_vm._v("wifi_off")]), _vm._v("\n      Offline\n    ")], 1)], 1), _vm.sortAndFilter(this.calls).length === 0 ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n        " + _vm._s(_vm.$vuetify.t('$vuetify.calls.noAssignments')) + "\n      ")])], 1)], 1) : _vm._e(), _vm._l(_vm.sortAndFilter(this.calls), function (call) {
    return _c('v-flex', {
      key: call.id,
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      key: call.id,
      class: _vm.callBG(call.status).class,
      attrs: {
        "to": {
          name: 'callDetail',
          params: {
            id: call.id
          }
        },
        "color": _vm.callBG(call.status).background,
        "raised": "",
        "tile": ""
      }
    }, [_c('v-card-title', {
      class: _vm.callBG(call.status).header
    }, [_vm._v("\n        " + _vm._s(call.company) + "\n        "), _c('v-spacer'), call.is_new ? _c('v-icon', {
      attrs: {
        "color": "yellow"
      }
    }, [_vm._v("star")]) : _vm._e()], 1), _c('v-card-text', {
      staticClass: "call",
      attrs: {
        "status": call.status,
        "id": call.id
      }
    }, [_c('div', {
      staticClass: "text-xs-left call-description blue-grey--text"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.callRef')) + ":")]), _vm._v("\n          " + _vm._s(call.call_remote_id) + "\n              \n\n          "), _c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.postcode')) + ":")]), _vm._v("\n          " + _vm._s(call.postcode) + "\n        ")]), _c('div', {
      staticClass: "text-xs-left call-description blue-grey--text"
    }, [_c('strong', [_vm._v(_vm._s(_vm.$vuetify.t('$vuetify.calls.scheduledDate')) + ":")]), _vm._v("\n          " + _vm._s(_vm.formatDatetimeWithoutTimeZone(call.scheduled_at)) + "\n        ")])])], 1)], 1);
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }